/**
 * Hide sidebar routes for custom_user when module access is not granted.
 */
export function filterRoutesByWebPermissions(routes = [], permissions = {}) {
  return (routes || [])
    .map((route) => {
      if (Array.isArray(route?.collapse) && route.collapse.length > 0) {
        const collapse = filterRoutesByWebPermissions(route.collapse, permissions);
        return { ...route, collapse };
      }
      return route;
    })
    .filter((route) => {
      if (route?.webModule) {
        return Boolean(permissions?.[route.webModule]?.access);
      }
      if (Array.isArray(route?.collapse)) {
        return route.collapse.length > 0;
      }
      return true;
    });
}
